import * as React from "react";
function SvgLoDash(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M0 22.2h48v3.5H0v-3.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLoDash);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
